"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nanoid = void 0;
const nanoid_1 = require("nanoid");
const nanoid = (size = 21) => {
    return (0, nanoid_1.customRandom)(nanoid_1.urlAlphabet, size, nanoid_1.random)();
};
exports.nanoid = nanoid;
//# sourceMappingURL=index.js.map